/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import Close from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      margin: "4rem 0rem 2rem 0rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 1rem 1rem 1rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
    padding: "2rem 0rem 2rem 0rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      margin: "0.5rem 0rem 0rem 0rem",
      padding: "2rem 0rem 0rem 0rem",
      gap: "1rem",
    },
  },
  heading: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: "600",
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
    },
  },
  imageGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    margin: "2.5rem 0rem 2.5rem 0rem",
    "& img": {
      width: "605px",
      height: "428px",
      objectFit: "cover",
      borderRadius: "0.5rem",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
        height: "auto",
      },
      cursor: "pointer",
    },
  },
  iconTextCard: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "1rem",
    width: "100%",
  },

  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "1rem",
    width: "100%",
  },
  imgdiv: {
    width: "817px",
    height: "577px",
    objectFit: "cover",
    padding: "0rem 2rem 0rem 2rem",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "auto",
    },
  },
  description: {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.688rem",
    color: "#202020",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.25rem",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.5rem",
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#A8626C",
    background: "#FFFFFF",
    border: "1px solid #A8626C",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#A8626C",
      color: "#FFFFFF",
    },
  },
  activeTimeButton: {
    background: "#A8626C",
    color: "#FFFFFF",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      gap: "1rem",
      alignItems: "flex-start",
    },
  },
  typecontent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1.5rem",
  },

  contentcard: {
    width: "100%",
    padding: "1rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "1rem",
  },

  cardText: {
    fontSize: "0.813rem",
    fontWeight: 400,
    lineHeight: "1.75rem",
    color: "#000000",
  },

  cardsubText: {
    fontSize: "0.813rem",
    fontWeight: 400,
    lineHeight: "1.688rem",
    color: "#666666",
  },
  dialogHeader: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "1.25rem",
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0 1rem",
  },
  dialogDetails: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1rem",
    width: "100%",
    padding: "1rem",
    margin: "1rem auto",
    [theme.breakpoints.down("xs")]: {
      padding: "0.5rem",
    },
  },
  dialogCard: {
    padding: "1rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "1rem",
    background: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  dialogPaper: {
    margin: 0,
    maxWidth: "100%",
    maxHeight: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "100%",
    padding: "2rem 1rem",
    overflowY: "auto",
  },
  dialogImage: {
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
  },
  closeButton: {
    position: "absolute",
    right: "1rem",
    top: "1.5rem",
    color: "#A8626C",
    zIndex: 1,
  },
}));

const FloorPlanMobile = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [touchStart, setTouchStart] = React.useState(null);
  const [touchEnd, setTouchEnd] = React.useState(null);
  // Touch handlers
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      handleNext();
    }
    if (isRightSwipe) {
      handlePrevious();
    }
  };

  const handleNext = () => {
    setActiveStep((prevStep) => (prevStep + 1) % images.length);
  };

  const handlePrevious = () => {
    setActiveStep((prevStep) => (prevStep - 1 + images.length) % images.length);
  };

  const handleImageClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const images = [
    {
      src: "images/icons/heavie/halcyon/type2.webp",
      type: "Type 1",
      cards: [
        { title: "SERIES", description: "301 -901" },
        { title: "CARPET AREA", description: "1522 SFT" },
        { title: "PLINTH AREA", description: "1748 SFT" },
        { title: "SBA", description: "2187 SFT" },
      ],
    },
    {
      src: "images/icons/heavie/halcyon/type4.webp",
      type: "Type 2",
      cards: [
        { title: "SERIES", description: "302 -902" },
        { title: "CARPET AREA", description: "1432 SFT" },
        { title: "PLINTH AREA", description: "1650 SFT" },
        { title: "SBA", description: "2065 SFT" },
      ],
    },
    {
      src: "images/icons/heavie/halcyon/type3.webp",
      type: "Type 3",
      cards: [
        { title: "SERIES", description: "303 -903" },
        { title: "CARPET AREA", description: "1645 SFT" },
        { title: "PLINTH AREA", description: "1880 SFT" },
        { title: "SBA", description: "2352 SFT" },
      ],
    },
    {
      src: "images/icons/heavie/halcyon/type1.webp",
      type: "Type 4",
      cards: [
        { title: "SERIES", description: "304 -904" },
        { title: "CARPET AREA", description: "1645 SFT" },
        { title: "PLINTH AREA", description: "1883 SFT" },
        { title: "SBA", description: "2357 SFT" },
      ],
    },
  ];

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleCloseDialog}
        classes={{ paper: classes.dialogPaper }}
      >
        <IconButton
          className={classes.closeButton}
          onClick={handleCloseDialog}
          aria-label="close"
        >
          <Close />
        </IconButton>
        <div
          className={classes.dialogContent}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          {" "}
          <Typography
            variant="h6"
            className={classes.dialogHeader}
          >
            {images[activeStep].type}
          </Typography>
          <img
            src={images[activeStep].src}
            alt={`Floor Plan ${images[activeStep].type}`}
            className={classes.dialogImage}
          />
          <div className={classes.dialogDetails}>
            {images[activeStep].cards.map((card, index) => (
              <div
                key={index}
                className={classes.dialogCard}
              >
                <Typography
                  variant="body2"
                  className={classes.cardText}
                >
                  {card.title}
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.cardsubText}
                >
                  {card.description}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Dialog>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <Typography
            variant="h6"
            component="span"
            className={classes.heading}
          >
            The blueprint of your peace, perfected
          </Typography>

          <div className={classes.timeButtons}>
            {images.map((image, index) => (
              <button
                key={index}
                className={`${classes.timeButton} ${activeStep === index ? classes.activeTimeButton : ""}`}
                onClick={() => setActiveStep(index)}
              >
                {image.type}
              </button>
            ))}
          </div>
        </div>
        {images.map(
          (image, index) =>
            activeStep === index && (
              <div
                key={index}
                className={classes.sectionContainer}
              >
                <img
                  alt={`eden-floor-plan-${image.type}`}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  src={image.src}
                  className={classes.imgdiv}
                  onClick={handleImageClick} // Add click handler
                />
                <div className={classes.text}>
                  <Typography
                    variant="h6"
                    component="h6"
                    className={classes.heading}
                  >
                    {image.heading}
                  </Typography>
                  <Typography
                    variant="h3"
                    component="h3"
                    className={classes.subHeading}
                  >
                    {image.subHeading}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="span"
                    className={classes.description}
                  >
                    {image.description}
                  </Typography>
                </div>
                <div className={classes.iconTextCard}>
                  {image.cards.map((card, cardIndex) => (
                    <div
                      key={cardIndex}
                      className={classes.contentcard}
                    >
                      <Typography
                        variant="body2"
                        className={classes.cardText}
                      >
                        {card.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.cardsubText}
                      >
                        {card.description}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            ),
        )}
      </div>
    </React.Fragment>
  );
};

export default FloorPlanMobile;
